import React, { useState, useSelector } from 'react'
import { Button, Popover } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { formatCurrencyRound } from "../../app/util";
import moment from "moment";
function InfoPopover({ anchorEl, setAnchorEl, popOverData, revertData, isOpen, }) {
    let { stay_date, sellRate, otb, forecast, room_code, isBase, edited, room_type_data, columnData, currency_symbol, acceptRecMethod, dataIndex, isRoomTypePricing, pricing_model } = popOverData;
    const [innerEl, setInnerEl] = useState(null)
    const [arrowTop, setArrowTop] = React.useState("50%");
    let popoverClass = (isOpen) ? "info-popover open" : "info-popover";

    const isPastDate = moment(stay_date).startOf('day').isBefore(moment().startOf('day'));

    // let RecSellRate = columnData?.RecSellRate || "";
    const { RecSellRate, resolved_sell_rate, is_rate_overridden, overridden_at, overridden_by, current_differential, lodgiq_differential, baseRoomSellRate, auto_rate_push_enabled } = columnData || {};
    let disableRecRateAcceptBtn = false;
    let rateDifferential = "";
    let rateDifferential_txt = "";
    let rateDifferentialVal = 0;
    let autoPushRateDifferentialVal = 0;
    let ratesMatch = false;
    if (is_rate_overridden) {
        if (isBase) {
            rateDifferential = "Rate";
            rateDifferential_txt = "LodgIQ Rate";
            rateDifferentialVal = RecSellRate ? formatCurrencyRound(currency_symbol, RecSellRate) : formatCurrencyRound(currency_symbol, 0);
            autoPushRateDifferentialVal = RecSellRate ? formatCurrencyRound(currency_symbol, RecSellRate) : formatCurrencyRound(currency_symbol, 0);
            let numericSellRate = Number(String(sellRate).replace(/[^0-9.-]/g, ''));
            if (RecSellRate !== undefined && RecSellRate !== null && sellRate !== undefined && sellRate !== null && sellRate !== '' && !isNaN(numericSellRate) && Number(RecSellRate) === numericSellRate) {
                ratesMatch = true;
            }
        }
        else {
            rateDifferential = "Differential";
            rateDifferential_txt = pricing_model=== 1 ? "Seasonal Differential" : "LodgIQ Differential";
            rateDifferentialVal = (lodgiq_differential !== null && lodgiq_differential !== undefined) ? formatCurrencyRound(currency_symbol, lodgiq_differential) : formatCurrencyRound(currency_symbol, 0);
            autoPushRateDifferentialVal = baseRoomSellRate > 0 && lodgiq_differential > 0 ? formatCurrencyRound(currency_symbol, baseRoomSellRate + lodgiq_differential) : formatCurrencyRound(currency_symbol, 0);
            if (current_differential !== undefined && current_differential !== null && lodgiq_differential !== undefined && lodgiq_differential !== null && Number(current_differential) === Number(lodgiq_differential)) {
                ratesMatch = true;
            }
        }

        // if ((RecSellRate === sellRate) || !RecSellRate) {
        //     disableRecRateAcceptBtn = true;
        // }
        // if (current_differential && lodgiq_differential && current_differential === lodgiq_differential) {
        //     disableRecRateAcceptBtn = true;
        // }
    }

    const handleClick = () => {
        // { checked, index, sub_col_index, subcol_id, dateData }
        if (acceptRecMethod && !disableRecRateAcceptBtn) {
            // { checked:true, trype:'single', stay_date, room_code, column:columnData }
            if (isRoomTypePricing) {
                acceptRecMethod({ checked: true, type: 'Single', stay_date, room_code, column: columnData });
            } else {
                acceptRecMethod({ checked: true, index: dataIndex, subcol_id: "pricing_Approve" });
            }
        }
        setAnchorEl(null);
        setInnerEl(null);
    }


    let popOver = (<Popover
        id={"infoPopover"}
        open={Boolean(innerEl)}
        anchorEl={innerEl}
        onClose={() => {
            setAnchorEl(null)
            setInnerEl(null)
            //setIsOpen(false);

        }}
        modifiers={{
            preventOverflow: {
                enabled: true,
                boundariesElement: "window"
            },
            arrow: {
                enabled: true,

            }
        }}
        anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'center',
            horizontal: 'left',
        }}
        className="info-popover"
        PaperProps={{
            sx: {
                ml: "12px",
                width: "max-content",
                position: 'relative',
                overflow: 'visible',
                '&:before': {
                    // content: '""',
                    // display: 'block',
                    // position: 'absolute',
                    // left: '-12px', // Adjust position as needed
                    // top: arrowTop,
                    // width: 0,
                    // height: 0,
                    // borderTop: '12px solid transparent',
                    // borderBottom: '12px solid transparent',
                    // borderRight: '14px solid #F8F9FA', // Triangle color
                    // transform: 'translateY(-50%)',
                    // filter: 'drop-shadow(-4px -5px 15px rgba(0, 0, 0, 0.9))', // Adds soft shadow
                    // zIndex: 1,

                    content: '""',
                    display: "block",
                    position: "absolute",
                    left: "-11px",
                    top: "50%",
                    width: 0,
                    height: 0,
                    borderTop: "9px solid transparent",
                    borderBottom: "9px solid transparent",
                    borderRight: "11px solid #F8F9FA",
                    transform: "translateY(-50%)",
                    filter: "drop-shadow(-5px -4px 16px rgba(0, 0, 0, 0.9))",
                    zIndex: 1

                }
            },
        }}
    >


        {/* <div className="popover-arrow popover-arrow-lc"></div> */}
        <div className="heading">{moment(stay_date).format("ddd, MMM DD, YYYY")}</div>
        {isRoomTypePricing && (
            <div className="info-section">
                <div className="data-head">
                    <div className='head-title head-cell'></div>
                    <div className='head-occ head-cell'>Occ%</div>
                    <div className='head-adr head-cell'>ADR</div>
                </div>
                <div className="data-body">
                    <div className='body-title data-cell'>OTB</div>
                    <div className='body-occ data-cell'>{otb.occ}</div>
                    <div className='body-adr data-cell'>{otb.adr}</div>
                </div>
                <div className="data-body forecast">
                    <div className='body-title data-cell'>Forecast</div>
                    <div className='body-occ data-cell'>{forecast.occ}</div>
                    <div className='body-adr data-cell'>{forecast.adr}</div>
                </div>
            </div>
        )}
        {is_rate_overridden && !ratesMatch && (
            <div className='accept_message'>
                {auto_rate_push_enabled ? (<>
                    <p>
                        Auto rate push paused on <span className='fwmid'>{moment(overridden_at).format("ddd, MMM DD, YYYY")} by {overridden_by}.</span>
                        <br />
                        Resuming will apply <span className='fwmid'>{autoPushRateDifferentialVal}</span>.
                        <br />
                        Click <span className='fwmid'>Accept Recommendation</span> to resume.
                    </p>
                    {!isPastDate &&
                        <Button onClick={handleClick} className='outline-btn' variant="outlined" size="small" >Accept Recommendation</Button>
                    }
                </>
                ) : (<>
                    <p>
                        The Current {rateDifferential} was Overridden on {moment(overridden_at).format("ddd, MMM DD, YYYY")}, by <span className='fwmid'>{overridden_by}.</span>
                        {!isPastDate && <>
                            <br />
                            Click <span className='fwmid'>Accept Recommendation</span> to Apply the {rateDifferential_txt} of <span className='fwmid'>{rateDifferentialVal}.</span>
                        </>}
                    </p>

                    {!isPastDate &&
                        <Button onClick={handleClick} className='outline-btn' variant="outlined" size="small" >Accept Recommendation</Button>
                    }
                </>)}
            </div>
        )}

        {edited && (<div className="revert-btns">
            <Button variant="outlined" size="small" onClick={() => {
                revertData("single", stay_date, room_code, isBase)
            }}>Revert</Button>
            <Button variant="outlined" size="small" onClick={() => {
                revertData("day", stay_date)
            }}>Revert Day</Button>
        </div>)
        }
    </Popover>)
    return (<>
        <InfoOutlinedIcon className="info-icon" onClick={(event) => {
            // setAnchorEl(event.currentTarget);
            setInnerEl(event.currentTarget)
        }} />
        {popOver}
    </>)


}

export default InfoPopover
